module.exports = __webpack_public_path__ + "img/courses8.b5ef908c.jpg";